module.exports = __webpack_public_path__ + "static/img/200116.11d1c6b9.png";